import { render, staticRenderFns } from "./dlt_excel_fabu.vue?vue&type=template&id=34c880a4&scoped=true"
import script from "./dlt_excel_fabu.vue?vue&type=script&lang=js"
export * from "./dlt_excel_fabu.vue?vue&type=script&lang=js"
import style0 from "./dlt_excel_fabu.vue?vue&type=style&index=0&id=34c880a4&prod&lang=scss"
import style1 from "./dlt_excel_fabu.vue?vue&type=style&index=1&id=34c880a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c880a4",
  null
  
)

export default component.exports